// This file will contain all the role specific dashboards

import { AllSectionsProps } from "../Cards/Interfaces/DashboardContainer";
import { ContactUsSection } from "./ContactUsSection";
import { AnnouncementSection } from "./AnnouncementSection";
import { ProjectTrendsComponent } from "../ProjectTrends/ProjectTrends";
import { HistorySection } from "./HistorySection";
import { CEOTopDashboardContainer, DesignerTopDashboardContainer, FacilitatorTopDashboardContainer, ITTopDashboardContainer, PurchaserTopDashboardContainer } from "../Containers/MainDashboardContainer";
import { AccountantTopDashboardContainer } from "../Containers/AccountantDashboardContainer";
import { EstimatorTopDashboardContainer } from "../Containers/MainDashboardContainer";
import { AdminTopDashboardContainer } from "../Containers/MainDashboardContainer";

export function AdminDashboard(props: AllSectionsProps) {
    return (
        <>
            {props.contactUs.length > 0 && <ContactUsSection {...props} />}

            {props.announcements.length > 0 && <AnnouncementSection {...props} />}

            <AdminTopDashboardContainer {...props} />

            <ProjectTrendsComponent />

            <HistorySection />
        </>
    )
}

export function CEODashboard(props: AllSectionsProps) {
    return (
        <>
            {props.contactUs.length > 0 && <ContactUsSection {...props} />}

            {props.announcements.length > 0 && <AnnouncementSection {...props} />}

            <CEOTopDashboardContainer {...props} />

            <ProjectTrendsComponent />

            <HistorySection />
        </>
    )
}

export function AccountantDashboard(props: AllSectionsProps) {
    return (
        <>
            {props.announcements.length > 0 && <AnnouncementSection {...props} />}

            <AccountantTopDashboardContainer {...props} />

            <ProjectTrendsComponent />

            <HistorySection />
        </>
    )
}

export function EstimatorDashboard(props: AllSectionsProps) {
    return (
        <>
            {props.announcements.length > 0 && <AnnouncementSection {...props} />}

            <EstimatorTopDashboardContainer {...props} />

            <ProjectTrendsComponent />

            <HistorySection />
        </>
    )
}

export function DesignerDashboard(props: AllSectionsProps) {
    return (
        <>
            {props.announcements.length > 0 && <AnnouncementSection {...props} />}

            <DesignerTopDashboardContainer {...props} />

            <HistorySection />
        </>
    )
}

export function PurchaserDashboard(props: AllSectionsProps) {
    return (
        <>
            {props.announcements.length > 0 && <AnnouncementSection {...props} />}

            <PurchaserTopDashboardContainer {...props} />

            <ProjectTrendsComponent />

            <HistorySection />
        </>
    )
}

export function FacilitatorDashboard(props: AllSectionsProps) {
    return (
        <>
            {props.announcements.length > 0 && <AnnouncementSection {...props} />}

            <FacilitatorTopDashboardContainer {...props} />

            <HistorySection />
        </>
    )
}

export function ITDashboard(props: AllSectionsProps) {
    return (
        <>
            {props.announcements.length > 0 && <AnnouncementSection {...props} />}

            <ITTopDashboardContainer {...props} />

            <HistorySection />
        </>
    )
}